/**
 * Custodian collateral: approve (DAI) → addCollateral on-chain → tell the backend.
 *
 * This screen is where the ERC-4337 nonce collision was originally found and
 * documented ([Collateral.jsx:165]): a smart account does not bump its EVM
 * nonce, so `approve` and `addCollateral` resolved to the SAME nonce and a
 * nonce-only key made the two steps overwrite each other. The engine's keys are
 * step-scoped for precisely that reason, so the collision cannot recur.
 *
 * The `addCollateral` step has no on-chain verifier: the router does not expose
 * "did this specific deposit land", only the resulting total, which cannot
 * distinguish our transaction from an earlier one. Recovery resolves it by hash
 * with the nonce scan as fallback — and the post-confirmation effect is
 * idempotent server-side regardless.
 */

import { registerFlow } from "../flows";
import { approveSatisfied } from "../verifiers";

export const COLLATERAL_FLOW = "collateral";
export const COLLATERAL_TX_STEPS = { APPROVE: "approve", ADD: "addCollateral" };

registerFlow({
  id: COLLATERAL_FLOW,
  steps: {
    [COLLATERAL_TX_STEPS.APPROVE]: { verifyOnChain: approveSatisfied },
    [COLLATERAL_TX_STEPS.ADD]: {},
  },
});
